import {
  FormDibattimentoViewComponent
} from '../../../../penale/fascicoloFormShared/form-dibattimento/view/form-dibattimento-view.component';
import {
  FascicoloRitiAlternativi
} from '../../../../penale/fascicoloFormShared/models/riti-alternativi/fascicolo-riti-alternativi';
import {
  FormIndaginiPreliminariViewComponent
} from '../../../../penale/fascicoloFormShared/form-indagini-preliminari/view/form-indagini-preliminari-view.component';
import {
  FormDibattimentoComponent
} from '../../../../penale/fascicoloFormShared/form-dibattimento/form-dibattimento.component';
import {
  FormIndaginiPreliminariComponent
} from '../../../../penale/fascicoloFormShared/form-indagini-preliminari/form-indagini-preliminari.component';
import {
  FormRitiAlternativiViewComponent
} from '../../../../penale/fascicoloFormShared/form-riti-alternativi/view/form-riti-alternativi-view.component';
import {
  FormRitiAlternativiComponent
} from '../../../../penale/fascicoloFormShared/form-riti-alternativi/form-riti-alternativi.component';
import {FascicoloDibattimento} from '../../../../penale/fascicoloFormShared/models/dibattimento/fascicolo-dibattimento';
import {
  FascicoloIndaginiPreliminari
} from '../../../../penale/fascicoloFormShared/models/indagini-preliminari/fascicolo-indagini-preliminari';
import {
  FormCautelareViewComponent
} from '../../../../penale/fascicoloFormShared/form-cautelare/view/form-cautelare-view.component';
import {FormCautelareComponent} from '../../../../penale/fascicoloFormShared/form-cautelare/form-cautelare.component';
import {FascicoloCautelare} from '../../../../penale/fascicoloFormShared/models/cautelare/fascicolo-cautelare';
import { FascicoloOrdinario } from '../../../../penale/fascicoloFormShared/models/ordinario/fascicolo-ordinario';
import { FormOrdinarioViewComponent } from '../../../../penale/fascicoloFormShared/form-ordinario/view/form-ordinario-view.component';
import { FormOrdinarioComponent } from '../../../../penale/fascicoloFormShared/form-ordinario/form-ordinario.component';
import { FascicoloGenerico } from 'src/app/penale/fascicoloFormShared/models/generico/fascicolo-generico';
import { FormGenericoViewComponent } from 'src/app/penale/fascicoloFormShared/form-generico/view/form-generico-view.component';
import { FormGenericoComponent } from 'src/app/penale/fascicoloFormShared/form-generico/form-generico.component';
import { FormUdienzaPreliminareViewComponent } from 'src/app/penale/fascicoloFormShared/form-udienza-preliminare/view/form-udienza-preliminare-view.component';
import { FormUdienzaPreliminareComponent } from 'src/app/penale/fascicoloFormShared/form-udienza-preliminare/form-udienza-preliminare.component';
import { FascicoloUdienzaPreliminare } from 'src/app/penale/fascicoloFormShared/models/udienza-preliminare/fascicolo-udienza-preliminare';
import { FormPredibattimentoViewComponent } from 'src/app/penale/fascicoloFormShared/form-predibattimento/view/form-predibattimento-view.component';
import { FormPredibattimentoComponent } from 'src/app/penale/fascicoloFormShared/form-predibattimento/form-predibattimento.component';
import { FascicoloPredibattimento } from 'src/app/penale/fascicoloFormShared/models/predibattimento/fascicolo-predibattimento';



export function getComponentFromFormTenantPenale(idFormTenant, view = false) {

  switch (idFormTenant) {
    case 'PenCau_PRD': {
      return view ? FormCautelareViewComponent : FormCautelareComponent; // "CAUTELARE"
    }
    case 'PenDib_PRD': {
      return view ? FormDibattimentoViewComponent : FormDibattimentoComponent; // "DIBATTIMENTO"
    }
    case 'PenRal_PRD': {
      return view ? FormRitiAlternativiViewComponent : FormRitiAlternativiComponent; // "RITI ALTERNATIVI "
    }
    case 'PenInd_PRD': {
      return view ? FormIndaginiPreliminariViewComponent : FormIndaginiPreliminariComponent; // "INDAGINI PRELIMINARI"
    }
    case 'PenOrd_PRD': {
      return view ? FormOrdinarioViewComponent : FormOrdinarioComponent; // "ORDINARIO";
    }
    case 'PenGen_PRD': {
      return view ? FormGenericoViewComponent : FormGenericoComponent; // "GENERICO";
    }
    case 'PenUdiPre_PRD': {
      return view ? FormUdienzaPreliminareViewComponent : FormUdienzaPreliminareComponent; // "UDIENZA PRELIMINARE";
    }
    case 'PenPreDib_PRD': {
      return view ? FormPredibattimentoViewComponent : FormPredibattimentoComponent; // "PREDIBATTIMENTO"
    }
  }
}

export function getFascicoloPenale(genericFascicolo): any {
  switch (genericFascicolo) {
    case 'cautelare': {
      return new FascicoloCautelare();
    }
    case 'dibattimento': {
      return new FascicoloDibattimento();
    }
    case 'ritoalternativo': {
      return new FascicoloRitiAlternativi();
    }
    case 'indaginipreliminari': {
      return new FascicoloIndaginiPreliminari();
    }
    case 'ordinario': {
      return new FascicoloOrdinario();
    }
    case 'genericogiudiziale': {
      return new FascicoloGenerico();
    }
    case 'udienzapreliminare': {
      return new FascicoloUdienzaPreliminare();
    }
    case 'predibattimento': {
      return new FascicoloPredibattimento();
    }
  }
}
